import React from 'react'
import PatientSearch from '../PatientSearch/PatientSearch.jsx'

const calculateStyle = (myPos, parentPos) => {
  const style = {
    left: parentPos.left - myPos.width / 2,
    top: parentPos.bottom - 10 // move it up just slightly for aesthetics
  }

  // left cant be less then left half of widget
  style.left = Math.max(style.left, myPos.width / 2)
  // left cant be greater than width of window - right half of widget
  style.left = Math.min(style.left, window.innerWidth - myPos.width / 2)
  // top cant be greater than bottom of window - widget height
  style.top = Math.min(style.top, window.innerHeight - myPos.height)
  return style
}

const RecentPatientsWidget = React.forwardRef(function RecentPatientsWidget(props, ref) {
  const self = React.useRef()
  const [style, setStyle] = React.useState({})

  React.useImperativeHandle(ref, () => ({ calculateStyle }), [])

  const calculatePosition = React.useCallback(() => {
    if (self.current == null || props.parentRef == null) {
      // make sure this isn't called during rendering, and that we have a parent to anchor to
      return
    }
    const myPos = self.current.getBoundingClientRect()
    const parentPos = props.parentRef.getBoundingClientRect()
    const next = calculateStyle(myPos, parentPos)

    setStyle(prev =>
      next.left !== prev.left || next.top !== prev.top ? next : prev
    )
  }, [props.parentRef])
  React.useEffect(() => {
    window.addEventListener('resize', calculatePosition)
    calculatePosition()
    return () => {
      window.removeEventListener('resize', calculatePosition)
    }
  }, [calculatePosition])
  return (
    <React.Fragment>
      <div
        className="recent-patients-screen-cover"
        onClick={props.closeSelf}
      />
      <div
        className="recent-patients-widget"
        ref={self}
        style={{
          ...(props.fromMoreIcon ? {
            right: '55px',
          }: {})
        }}
      >
        {props.appConfig.patientSearchHistory == null ? (
          <div>{'No search history to display'}</div>
        ) : (
          props.appConfig.patientSearchHistory.map((patient, idx) => {
            return (
              <div
                key={idx}
                onClick={e => {
                  PatientSearch.pushUrl(
                    props.router.location.pathname,
                    props.appConfig,
                    patient
                  )
                }}
              >
                {`(${idx + 1}) ${PatientSearch.buildPatientString(patient)}`}
              </div>
            )
          })
        )}
      </div>
    </React.Fragment>
  )
})

export default RecentPatientsWidget
